import { createAsyncThunk } from "@reduxjs/toolkit";
import { IIntegratorList } from "models/Employee/IntegratoInfo.model";
import { ITokenModel } from "models/Login/token.model";

import { IntegratorList } from "services/integrators.service";

// for Integrator Page
export const integratorListAsync = createAsyncThunk(
  "IntegratorList",
  async (integratorListReq: ITokenModel): Promise<IIntegratorList> => {
    try {
      const response = await IntegratorList(integratorListReq);
      return response;
    } catch (error: any) {
      throw error;
    }
  }
);
